<template>
  <div>
    <span v-for="i in l" :key="i.flag">
      <template v-if="i.val">{{ i.val }}</template>
      <v-chip v-if="i.flag" outline :color="i.color || 'primary'">{{
        i.flag
      }}</v-chip>
    </span>
  </div>
</template>
<script>
export default {
  name: "row-flag",
  props: {
    cfg: [Object, Array],
  },
  data() {
    return { l: [] };
  },
  watch: {
    cfg() {
      this.init();
    }
  },
  methods: {
    init() {
      let self = this, cfg = self.cfg;
      if (Array.isArray(cfg)) {
        self.l = cfg;
      } else {
        self.l = [cfg];
      }
    }
  },
  created() {
    this.init();
  }
};
</script>
<style scoped>
.v-chip {
  font-size: 10px !important;
  height: 20px !important;
  line-height: 20px !important;
}
</style>